import { CategoryTable } from "../../../api/it/account-category/account-category-api-state";
import TableEmpty from "../../ui/table-empty";

interface Props {
    data: CategoryTable[]
    handleSelect: (value: CategoryTable) => void;
}

export default function CategoryListTBody({ data, handleSelect }: Props) {
    return (
        <tbody className="divide-y divide-gray-100">
            {data.length === 0 || !data ? (
                <TableEmpty />
            ) : data.map((val, index) => {
                const status = val.status ? 'Active' : 'Inactive'
                const statusStyle = val.status ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                return (
                    <tr 
                        key={val.id}
                        className={`group cursor-pointer border-b border-gray-100 text-xs transition-colors duration-150 hover:bg-[#186cb2]/5 ${ index % 2 === 0 ? 'bg-white' : 'bg-gray-50/60' }`}
                    >
                        <td className="px-3 py-3 text-gray-700 sm:px-4">
                            <span className={`${statusStyle} inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[10px] font-medium`}>
                                <span className="h-1.5 w-1.5 rounded-full bg-current" />
                                {status}
                            </span>
                        </td>
                        <td className='px-3 py-3 text-gray-700 sm:px-4'>
                            <div className="max-w-[180px] truncate" title={val.name}>
                                {val.name}
                            </div>
                        </td>
                        <td className='px-3 py-3 text-gray-700 sm:px-4'>
                            <div className="max-w-[180px] truncate" title={val.name}>
                                {val.code}
                            </div>
                        </td>
                        <td className="px-3 py-3 sm:px-4">
                            <button
                                type="button"
                                onClick={() => handleSelect(val)}
                                className="inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium text-[#186cb2] transition-colors hover:bg-[#186cb2]/10 hover:text-[#155b96]"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="1.8"
                                    className="h-3.5 w-3.5"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M12 20h9"
                                    />
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M16.5 3.5a2.121 2.121 0 0 1 3 3L8 18l-4 1 1-4L16.5 3.5z"
                                    />
                                </svg>
                                <span>Edit</span>
                            </button>
                        </td>
                    </tr>
                )
            })}
        </tbody>
    )
}
